/*
* create by nguyendx 2017/10/05
*/
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ConfirmDialogModule, GrowlModule, TooltipModule} from 'primeng/primeng';
import {HelperModule} from '../../../../common/helper/helper.module';
import {UploadService} from '../../../../common/services/Upload.service';
import {ScanStampComponent} from './scan_stamp.component';
import {ScanErrorComponent} from './box_scan_error.component';
import {ScanDefaultComponent} from './box_scan_default.component';
import {BoxBaoHanhFormComponent} from './box_baohanh_form.component';
import {BoxBusinessVendorComponent} from './box_business_vendor.component';
import {BoxProductInfoComponent} from './box_product_info.component';
import {BoxProductInfoMoreComponent} from './box_product_info_more.component';
import {BoxProductRelatedComponent} from './box_product_related.component';

@NgModule({
    imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ConfirmDialogModule,
        GrowlModule,
        TooltipModule,
        BrowserModule,
        HelperModule
    ],

    declarations: [
        ScanErrorComponent,
        ScanDefaultComponent,
        ScanStampComponent,

        BoxBaoHanhFormComponent,
        BoxBusinessVendorComponent,
        BoxProductInfoComponent,
        BoxProductInfoMoreComponent,
        BoxProductRelatedComponent,
    ],
    exports: [
        ScanErrorComponent,
        ScanDefaultComponent,
        ScanStampComponent,

        BoxBaoHanhFormComponent,
        BoxBusinessVendorComponent,
        BoxProductInfoComponent,
        BoxProductInfoMoreComponent,
        BoxProductRelatedComponent,
    ],
    providers: [UploadService]
})

export class ScanModule {
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/scan/scan.module.ts